// extracted by mini-css-extract-plugin
export default {"item":"savedCart_item__a1GD8"};